import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import * as React from 'react';
import { jsx as ___EmotionJSX } from "@emotion/react";
export var ErrorBoundary = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(ErrorBoundary, _React$PureComponent);

  var _super = _createSuper(ErrorBoundary);

  function ErrorBoundary() {
    var _this;

    _classCallCheck(this, ErrorBoundary);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      hasError: false
    });

    return _this;
  }

  _createClass(ErrorBoundary, [{
    key: "componentDidCatch",
    // eslint-disable-next-line class-methods-use-this
    value: function componentDidCatch(error) {
      this.props.onErrorReported(error);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          forceToShow = _this$props.forceToShow,
          children = _this$props.children;
      var hasError = this.state.hasError;

      if (hasError || forceToShow) {
        return ___EmotionJSX("div", {
          className: "dc-u-fx dc-u-fx-aic dc-u-fx-jcc dc-u-h-100pc dc-u-bgc-grey-400 dc-u-ta-center"
        }, ___EmotionJSX("h4", null, "Something went wrong, please reload the page or visit our", ' ', ___EmotionJSX("a", {
          href: "https://support.datacamp.com/",
          rel: "noopener noreferrer"
        }, "Support page"), ' ', "if the problem persists."));
      }

      if (!children) {
        return null;
      }

      return children;
    }
  }], [{
    key: "getDerivedStateFromError",
    value: function getDerivedStateFromError() {
      return {
        hasError: true
      };
    }
  }]);

  return ErrorBoundary;
}(React.PureComponent);

_defineProperty(ErrorBoundary, "defaultProps", {
  forceToShow: false
});